import Navbar from "../../components/navbar/navbar";
import Footer from "../../components/footer/Footer";
import complianceLogo from "../../assets/imgs/compliance_imgs/redesign-compliance/compliance-logo.png";
import { FaArrowRight } from "react-icons/fa";
import download from "../../assets/imgs/compliance_imgs/download.svg";
import phone from "../../assets/imgs/compliance_imgs/redesign-compliance/compliance-phone.png";
import check from "../../assets/imgs/compliance_imgs/check.svg";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import anticorruptionEsp from "../../assets/pdfs/A_PO_GALE_09.pdf";
import anticorruptionEng from "../../assets/pdfs/A_PO_GALE_09.pdf";
import pdfcomplianceEsp from "../../assets/pdfs/005_ABRIL_Codigo_de_conducta_24_02.pdf";
import pdfcomplianceEng from "../../assets/pdfs/007_ABRIL_Codigo_de_conducta_ing_24_02.pdf";
import navBarEn from "../../translations/en/navbar.json";
import navBarEs from "../../translations/es/navbar.json";
import Helmet from "react-helmet";
import "./compliance.css";
import "animate.css";
import ScrollToDynamic from "../../components/scrollToDynamic/scroolToDynamic";
import Commitment from "./commitment";
import Ambassadors from "./ambassadors";
import Breadcrumb from "../../components/breadcrumb/breadcrumb";

function Compliance() {
  const [tCompliance] = useTranslation("compliance");
  const [tSMetaData] = useTranslation("metaData");
  const heroSlidesRaw = tCompliance("hero.slides", { returnObjects: true });
  const heroSlides = Array.isArray(heroSlidesRaw) ? heroSlidesRaw : [];
  const [scrollY, setScrollY] = useState(0);
  const [heroIndex, setHeroIndex] = useState(0);
  const [animation1, setAnimation1] = useState(false);
  const [animation2, setAnimation2] = useState(false);
  // const [animation3, setAnimation3] = useState(false);
  const [animation4, setAnimation4] = useState(false);
  const [animation5, setAnimation5] = useState(false);
  const [animation6, setAnimation6] = useState(false);
  const [confidentialComplaintBtn, setConfidentialComplaintBtn] = useState('https://etica.resguarda.com/aeromexico/es/main.html')

  useEffect(() => {
    if(localStorage.getItem("lng")) {
      if(localStorage.getItem("lng") === 'us') {
        setConfidentialComplaintBtn('https://etica.resguarda.com/aeromexico/en/main.html');
      } else {
        setConfidentialComplaintBtn('https://etica.resguarda.com/aeromexico/es/main.html');
      }
    }
  })

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].compliance}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].compliance}`
  );

  const handlescroll = () => {
    setScrollY(window.scrollY || window.pageYOffset);
  };

  useEffect(() => {
    window.addEventListener("scroll", handlescroll);

    return () => {
      window.removeEventListener("scroll", handlescroll);
    };
  }, []);

  useEffect(() => {
    setAnimation1(scrollY >= 220);
  }, [scrollY]);

  useEffect(() => {
    setAnimation2(scrollY >= 640);
  }, [scrollY]);

  // useEffect(() => {
  //   setAnimation3(scrollY >= 1170);
  // }, [scrollY]);

  useEffect(() => {
    setAnimation4(scrollY >= 1300);
  }, [scrollY]);

  useEffect(() => {
    setAnimation5(scrollY >= 2000);
  }, [scrollY]);

  useEffect(() => {
    setAnimation6(scrollY >= 2500);
  }, [scrollY]);

  const showPdf = () => {
    if (localStorage.getItem("lng")) {
      localStorage.getItem("lng") === "es"
        ? window.open(pdfcomplianceEsp, "_blank")
        : window.open(pdfcomplianceEng, "_blank");
    } else {
      window.open(pdfcomplianceEsp, "_blank");
    }
    // saveAs(pdfcompliance, "Compliance");
  };

  const showInfoBooklet = () => {
    if (localStorage.getItem("lng")) {
      localStorage.getItem("lng") === "es"
        ? window.open(anticorruptionEsp, "_blank")
        : window.open(anticorruptionEng, "_blank");
    } else {
      window.open(anticorruptionEsp, "_blank");
    }
  };

  const prevHeroSlide = () => {
    if (!heroSlides.length) return;
    setHeroIndex((oldIndex) => (oldIndex === 0 ? heroSlides.length - 1 : oldIndex - 1));
  };
  const nextHeroSlide = () => {
    if (!heroSlides.length) return;
    setHeroIndex((oldIndex) => (oldIndex === heroSlides.length - 1 ? 0 : oldIndex + 1));
  };

  return (
    <>
      <Helmet>
        <title>{tSMetaData("compliance.title")}</title>
        <meta
          name="description"
          content={tSMetaData("compliance.description")}
        />
      </Helmet>
      <ScrollToDynamic />
      <Navbar />
      <Breadcrumb />

      <main className="compliance compliance-redesign">
        <section className="compliance_cover">
          <div className="compl_cover_text mt-4">
            <div
              key={heroIndex}
              className="col-lg-8 compliance-hero-content compliance-hero-content--animated"
              aria-live="polite"
            >
              <h1>{heroSlides[heroIndex]?.title || tCompliance("body.compliance")}</h1>
              <p>{heroSlides[heroIndex]?.text1 || ""}</p>
              {heroSlides[heroIndex]?.text2 ? <p className="hero-slide-text-secondary">{heroSlides[heroIndex].text2}</p> : null}
              <div className="compliance-hero-controls">
                <button type="button" className="compliance-hero-btn" onClick={prevHeroSlide}>
                  {tCompliance("hero.prev")}
                </button>
                {heroSlides.length > 1 ? (
                  <span className="compliance-hero-slide-indicator">
                    {tCompliance("hero.slideIndicator", {
                      current: heroIndex + 1,
                      total: heroSlides.length,
                      defaultValue: `${heroIndex + 1} / ${heroSlides.length}`,
                    })}
                  </span>
                ) : null}
                <button type="button" className="compliance-hero-btn" onClick={nextHeroSlide}>
                  {tCompliance("hero.next")}
                </button>
              </div>
            </div>
          </div>

          <div className="compli__cover__filter"></div>
          <div className="compli_cover_image bg_img"></div>
        </section>

        <Commitment />

        <section className="compliance_conduct">
          <article className="comp_conduct_intro">
            <div className="comp_cond_conta">
              <div
                className={
                  animation1
                    ? "comp_conduct_intro__icon animate__animated animate__fadeInUp"
                    : "comp_conduct_intro__icon"
                }
                aria-hidden
              >
                <img
                  src={complianceLogo}
                  alt=""
                  className="comp_conduct_intro__logo"
                  width={200}
                  height={72}
                  decoding="async"
                />
              </div>
              <h2
                className={
                  animation1 ? "animate__animated animate__fadeInUp" : ""
                }
              >
                {tCompliance("body.am")}
              </h2>
              <p
                className={
                  animation1 ? "animate__animated animate__fadeInUp" : ""
                }
              >
                {tCompliance("body.cv")}
              </p>
              <button
                type="button"
                className={
                  animation1
                    ? "btn-anticorruption-outline animate__animated animate__fadeInUp"
                    : "btn-anticorruption-outline"
                }
                onClick={showInfoBooklet}
                id="btnPoliticaAnticorrupcion"
              >
                {tCompliance("body.verDeclaracion")}
              </button>
            </div>
          </article>

          <div className="compliance-cards-stack">
            <article className="comp_conduct_info" id="section-codigo-conducta">
              <div className="comp_conduct_info_conta" id="comp_conduct_info_conta">
                <div
                  className={
                    animation2
                      ? "comp_conduct_info__icon animate__animated animate__fadeInUp"
                      : "comp_conduct_info__icon"
                  }
                  aria-hidden
                >
                  <svg viewBox="0 0 40 48" width="44" height="52" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8 4h24a2 2 0 0 1 2 2v36a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                    <path d="M12 12h16M12 20h16M12 28h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                </div>
                <h4
                  className={
                    animation2 ? "animate__animated animate__fadeInUp" : ""
                  }
                >
                  {tCompliance("body.conducta")}
                </h4>
                <p
                  className={
                    animation2 ? "animate__animated animate__fadeInUp" : ""
                  }
                >
                  {tCompliance("body.version")}
                </p>

                <a
                  href="#####"
                  onClick={(e) => {
                    e.preventDefault();
                    showPdf();
                  }}
                  id="btnConductaDescarga"
                  className={
                    animation2
                      ? "button button-primary btn-descargar-conducta animate__animated animate__fadeInUp"
                      : "button button-primary btn-descargar-conducta"
                  }
                  role="button"
                >
                  <img src={download} alt=""></img>
                  {tCompliance("body.descargar")}
                </a>
              </div>
            </article>

            <Ambassadors />
          </div>
        </section>

        <section className="compliance_ethics" id="compliance_ethics">
          <div className="comp_ethics_background"></div>
          <div className="compl_ethics_container">
            <div className="row">
              <div className="container">
                <div className="row align-items-center compliance-ethics-row">
                  <div className="col-lg-7 col-md-12 col-12 order-2 order-lg-1 d-flex flex-column">
                    <article className="compliance_ethics_information">
                      <h4
                        className={
                          animation5
                            ? "animate__animated animate__fadeInUp"
                            : ""
                        }
                      >
                        {tCompliance("body.linea")}
                      </h4>
                      <p
                        className={
                          animation5
                            ? "animate__animated animate__fadeInUp"
                            : ""
                        }
                      >
                        {tCompliance("body.reporta")}
                      </p>
                      <ul
                        className={
                          animation5
                            ? "compl_ethics_info_list animate__animated animate__fadeInUp"
                            : "compl_ethics_info_list"
                        }
                      >
                        <li>
                          <img src={check} alt=""></img>
                          <span>{tCompliance("body.actos")}</span>
                        </li>
                        <li>
                          <img src={check} alt=""></img>
                          <span>{tCompliance("body.discrminacion")}</span>
                        </li>
                        <li>
                          <img src={check} alt=""></img>
                          <span>{tCompliance("body.hostigamiento")}</span>
                        </li>
                        <li>
                          <img src={check} alt=""></img>
                          <span>{tCompliance("body.soborno")}</span>
                        </li>
                        <li>
                          <img src={check} alt=""></img>
                          <span>{tCompliance("body.acosos")}</span>
                        </li>
                      </ul>

                      <div className="compliance_ethics_footer compliance_ethics_footer--redesign">
                        <ul className="complience_ethics_footer_phone complience_ethics_footer_phone--redesign">
                          <li>
                            <span className="ethics-phone-icon" aria-hidden />
                            <div>
                              <label
                                className={
                                  animation5
                                    ? "animate__animated animate__fadeInUp"
                                    : ""
                                }
                              >
                                {tCompliance("body.mex")}
                              </label>
                              <a href="tel:8001120585" role="button">
                                800-112-0585
                              </a>
                            </div>
                          </li>
                          <li>
                            <span className="ethics-phone-icon" aria-hidden />
                            <div>
                              <label
                                className={
                                  animation5
                                    ? "animate__animated animate__fadeInUp"
                                    : ""
                                }
                              >
                                {tCompliance("body.usa")}
                              </label>
                              <a href="tel:18009212240" role="button" className="fade-in-up">
                                (00)1 800 921 2240
                              </a>
                            </div>
                          </li>
                        </ul>
                        <div className="compliance_ethics_footer_button">
                          <a
                            className={
                              animation5
                                ? "button button-primary btn-denuncia-full animate__animated animate__fadeInUp"
                                : "button button-primary btn-denuncia-full"
                            }
                            id="btnDenunciaConfidencial"
                            role="button"
                            target="_blank"
                            href={confidentialComplaintBtn}
                            rel="noreferrer"
                          >
                            {tCompliance("body.denuncia")}
                          </a>
                        </div>
                      </div>
                    </article>
                  </div>
                  <div className="col-lg-5 col-md-12 col-12 order-1 order-lg-2">
                    <div
                      className={
                        animation4
                          ? "compl_ethics_image animate__animated animate__fadeInUp"
                          : "compl_ethics_image"
                      }
                    >
                      <img src={phone} alt="" className="img-fluid"></img>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="compliance_ethics_footer_text">
          <div className="compl_ethics_footer_conta">
            <div className="compl_ethics_footer_logo">
              <img src={complianceLogo} alt=""></img>
              <p
                className={
                  animation6 ? "animate__animated animate__fadeInUp" : ""
                }
              >
                {tCompliance("body.link")}
              </p>
              <a
                className={
                  animation6
                    ? "button button-primary animate__animated animate__fadeInUp btn_compliance_mexico"
                    : "button button-primary btn_compliance_mexico"
                }
                id="btnAMCompliance"
                href={tCompliance("body.linkCompliance")}
                role="button"
                target="_blanck"
              >
                {tCompliance("body.compl")}{" "}
                <li>
                  <FaArrowRight />
                </li>
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}

export default Compliance;
